import React, { useState } from 'react'
import {
  Box,
  DemoBtn,
  DemoChips,
  DemoInput,
  DemoSelect,
  DemoTabs,
  DemoTextarea,
  Field,
  Flash,
  useFlash,
} from './demoKit'

/** Demos L2 interativas — formulários compostos com estado. */

const STATUS = [
  { value: 'aberto', label: 'Aberto' },
  { value: 'fechado', label: 'Fechado' },
  { value: 'cancelado', label: 'Cancelado' },
]

const FORM_MOCKS = {
  formActionsA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-head erp-mock-head--actions">
        <span />
        <div>
          <DemoBtn variant="outline" onClick={() => flash('Cancelado', 'warn')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Salvo ✓')}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  formActionsB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-head erp-mock-head--actions">
        <DemoBtn variant="ghost" onClick={() => flash('Cancelado', 'warn')}>
          Cancelar
        </DemoBtn>
        <div>
          <DemoBtn variant="danger-outline" onClick={() => flash('Excluído', 'err')}>
            Excluir
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Salvo ✓')}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  formActionsC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <DemoBtn block variant="primary" onClick={() => flash('Salvo ✓')}>
          Salvar
        </DemoBtn>
        <DemoBtn block variant="outline" onClick={() => flash('Cancelado', 'warn')}>
          Cancelar
        </DemoBtn>
        <DemoBtn block variant="danger-ghost" onClick={() => flash('Excluído', 'err')}>
          Excluir
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  formIdentityA: () => {
    const [f, setF] = useState({ nome: '', doc: '', email: '' })
    return (
      <Box>
        <Field label="Nome / Razão social">
          <DemoInput value={f.nome} onChange={(nome) => setF({ ...f, nome })} />
        </Field>
        <Field label="CNPJ">
          <DemoInput value={f.doc} onChange={(doc) => setF({ ...f, doc })} placeholder="00.000.000/0001-00" />
        </Field>
        <Field label="E-mail">
          <DemoInput value={f.email} onChange={(email) => setF({ ...f, email })} type="email" />
        </Field>
      </Box>
    )
  },
  formIdentityB: () => {
    const [f, setF] = useState({ nome: '', doc: '', email: '', tel: '' })
    return (
      <Box className="erp-mock-form-2">
        <Field label="Nome">
          <DemoInput value={f.nome} onChange={(nome) => setF({ ...f, nome })} />
        </Field>
        <Field label="Documento">
          <DemoInput value={f.doc} onChange={(doc) => setF({ ...f, doc })} />
        </Field>
        <Field label="E-mail">
          <DemoInput value={f.email} onChange={(email) => setF({ ...f, email })} />
        </Field>
        <Field label="Telefone">
          <DemoInput value={f.tel} onChange={(tel) => setF({ ...f, tel })} />
        </Field>
      </Box>
    )
  },
  formIdentityC: () => {
    const [f, setF] = useState({ nome: '', doc: '', email: '' })
    return (
      <Box className="erp-mock-row">
        <Field label="Nome">
          <DemoInput value={f.nome} onChange={(nome) => setF({ ...f, nome })} />
        </Field>
        <Field label="CPF/CNPJ">
          <DemoInput value={f.doc} onChange={(doc) => setF({ ...f, doc })} />
        </Field>
        <Field label="E-mail">
          <DemoInput value={f.email} onChange={(email) => setF({ ...f, email })} />
        </Field>
      </Box>
    )
  },

  formAddressA: () => {
    const [f, setF] = useState({ cep: '', uf: 'BA', log: '', num: '', cid: '', bairro: '' })
    return (
      <Box className="erp-mock-form-2">
        <Field label="CEP">
          <DemoInput value={f.cep} onChange={(cep) => setF({ ...f, cep })} />
        </Field>
        <Field label="UF">
          <DemoSelect
            value={f.uf}
            onChange={(uf) => setF({ ...f, uf })}
            options={[
              { value: 'BA', label: 'BA' },
              { value: 'SP', label: 'SP' },
              { value: 'RJ', label: 'RJ' },
            ]}
          />
        </Field>
        <Field label="Logradouro">
          <DemoInput value={f.log} onChange={(log) => setF({ ...f, log })} />
        </Field>
        <Field label="Número">
          <DemoInput value={f.num} onChange={(num) => setF({ ...f, num })} />
        </Field>
        <Field label="Cidade">
          <DemoInput value={f.cid} onChange={(cid) => setF({ ...f, cid })} />
        </Field>
        <Field label="Bairro">
          <DemoInput value={f.bairro} onChange={(bairro) => setF({ ...f, bairro })} />
        </Field>
      </Box>
    )
  },
  formAddressB: () => {
    const [f, setF] = useState({ cep: '', log: '', num: '', cid: '' })
    return (
      <Box>
        <Field label="CEP">
          <DemoInput value={f.cep} onChange={(cep) => setF({ ...f, cep })} />
        </Field>
        <Field label="Logradouro">
          <DemoInput value={f.log} onChange={(log) => setF({ ...f, log })} />
        </Field>
        <Field label="Número">
          <DemoInput value={f.num} onChange={(num) => setF({ ...f, num })} />
        </Field>
        <Field label="Cidade / UF">
          <DemoInput value={f.cid} onChange={(cid) => setF({ ...f, cid })} />
        </Field>
      </Box>
    )
  },
  formAddressC: () => {
    const [cep, setCep] = useState('')
    const [addr, setAddr] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <Box>
        <Field label="CEP">
          <div className="erp-mock-row">
            <DemoInput value={cep} onChange={setCep} placeholder="00000-000" />
            <DemoBtn
              variant="outline"
              onClick={() => {
                setAddr(cep ? `Rua Exemplo, 100 — Centro (${cep})` : '')
                flash(cep ? 'Endereço preenchido' : 'Informe o CEP', cep ? 'ok' : 'warn')
              }}
            >
              Buscar
            </DemoBtn>
          </div>
        </Field>
        <Field label="Endereço">
          <DemoInput value={addr} onChange={setAddr} placeholder="Preenchido após buscar" />
        </Field>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  formFiltersA: () => {
    const [status, setStatus] = useState('aberto')
    const [periodo, setPeriodo] = useState('2026-08')
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-filterbar">
        <DemoSelect value={status} onChange={setStatus} options={STATUS} />
        <DemoInput type="month" value={periodo} onChange={setPeriodo} />
        <DemoBtn variant="primary" onClick={() => flash(`Filtrado: ${status} · ${periodo}`)}>
          Filtrar
        </DemoBtn>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  formFiltersB: () => {
    const [chips, setChips] = useState(['Status: Aberto', 'Ago/2026'])
    return (
      <Box>
        <DemoChips
          values={chips}
          onRemove={(x) => setChips(chips.filter((c) => c !== x))}
          onAdd={() => {
            if (!chips.includes('EP: SSA')) setChips([...chips, 'EP: SSA'])
          }}
          addLabel="+ filtro"
        />
      </Box>
    )
  },
  formFiltersC: () => {
    const [status, setStatus] = useState('todos')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-drawer erp-mock-drawer--sm">
        <div className="erp-mock-drawer__bar">Filtros</div>
        <div className="erp-mock-drawer__body">
          <Field label="Status">
            <DemoSelect
              value={status}
              onChange={setStatus}
              options={[{ value: 'todos', label: 'Todos' }, ...STATUS]}
            />
          </Field>
          <DemoBtn variant="primary" onClick={() => flash('Aplicado')}>
            Aplicar
          </DemoBtn>
          <Flash message={msg} tone={tone} />
        </div>
      </div>
    )
  },

  formModalNewA: () => {
    const [nome, setNome] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-modal erp-mock-modal--sm">
        <div className="erp-mock-modal__bar">
          <strong>Novo</strong>
        </div>
        <div className="erp-mock-modal__body">
          <Field label="Nome">
            <DemoInput value={nome} onChange={setNome} />
          </Field>
        </div>
        <div className="erp-mock-modal__foot">
          <DemoBtn variant="outline" onClick={() => setNome('')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash(`Salvo: ${nome || '(vazio)'}`)}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  formModalNewB: () => {
    const [nome, setNome] = useState('')
    const [tipo, setTipo] = useState('a')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-modal">
        <div className="erp-mock-modal__bar">
          <strong>Novo registro</strong>
        </div>
        <div className="erp-mock-modal__body">
          <Field label="Nome">
            <DemoInput value={nome} onChange={setNome} />
          </Field>
          <Field label="Tipo">
            <DemoSelect
              value={tipo}
              onChange={setTipo}
              options={[
                { value: 'a', label: 'Tipo A' },
                { value: 'b', label: 'Tipo B' },
              ]}
            />
          </Field>
        </div>
        <div className="erp-mock-modal__foot">
          <DemoBtn variant="outline" onClick={() => flash('Cancelado', 'warn')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Salvo ✓')}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  formModalNewC: () => {
    const [tab, setTab] = useState('dados')
    const [nome, setNome] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-mock-modal erp-mock-modal--wide">
        <div className="erp-mock-modal__bar">
          <strong>Cadastro</strong>
        </div>
        <DemoTabs
          tabs={[
            { id: 'dados', label: 'Dados' },
            { id: 'contato', label: 'Contato' },
            { id: 'anexos', label: 'Anexos' },
          ]}
          active={tab}
          onChange={setTab}
        >
          {tab === 'dados' && (
            <Field label="Razão social">
              <DemoInput value={nome} onChange={setNome} />
            </Field>
          )}
          {tab !== 'dados' && <span className="small text-muted">Conteúdo da aba {tab}</span>}
        </DemoTabs>
        <div className="erp-mock-modal__foot">
          <DemoBtn variant="outline" onClick={() => flash('Cancelado', 'warn')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Salvo ✓')}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },

  formApprovalA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-apcard erp-mock-apcard--row">
        <div>
          <strong>Pedido #881</strong>
          <p>Compra — R$ 4.200</p>
        </div>
        <div>
          <DemoBtn variant="danger-outline" onClick={() => flash('Rejeitado', 'err')}>
            Rejeitar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Aprovado ✓')}>
            Aprovar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  formApprovalB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-apcard">
        <strong>Pedido #881</strong>
        <p>Compra de equipamentos — R$ 4.200</p>
        <div className="erp-mock-apcard__full">
          <DemoBtn variant="danger" onClick={() => flash('Rejeitado', 'err')}>
            Rejeitar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Aprovado ✓')}>
            Aprovar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
  formApprovalC: () => {
    const [motivo, setMotivo] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <Box className="erp-mock-apcard">
        <strong>Pedido #881</strong>
        <p>Compra — R$ 4.200</p>
        <Field label="Motivo (se rejeitar)">
          <DemoTextarea value={motivo} onChange={setMotivo} />
        </Field>
        <div>
          <DemoBtn
            variant="danger-outline"
            onClick={() =>
              flash(motivo ? `Rejeitado: ${motivo}` : 'Informe o motivo', motivo ? 'err' : 'warn')
            }
          >
            Rejeitar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Aprovado ✓')}>
            Aprovar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },

  formUploadA: () => {
    const [files, setFiles] = useState(['contrato.pdf', 'nota.xml'])
    return (
      <Box>
        <DemoBtn
          variant="outline"
          onClick={() => setFiles([...files, `arquivo-${files.length + 1}.pdf`])}
        >
          Anexar arquivo
        </DemoBtn>
        <ul className="erp-mock-filelist">
          {files.map((f) => (
            <li key={f}>
              {f}{' '}
              <button
                type="button"
                className="erp-mock-link"
                onClick={() => setFiles(files.filter((x) => x !== f))}
              >
                remover
              </button>
            </li>
          ))}
        </ul>
      </Box>
    )
  },
  formUploadB: () => {
    const [files, setFiles] = useState(['proposta.pdf'])
    return (
      <Box>
        <div
          className="erp-mock-drop"
          role="button"
          tabIndex={0}
          onClick={() => setFiles([...files, `drop-${files.length + 1}.pdf`])}
          onKeyDown={(e) => e.key === 'Enter' && setFiles([...files, 'arquivo.pdf'])}
        >
          Arraste ou clique para anexar
        </div>
        <ul className="erp-mock-filelist">
          {files.map((f) => (
            <li key={f}>{f}</li>
          ))}
        </ul>
      </Box>
    )
  },
  formUploadC: () => {
    const [items, setItems] = useState(['PDF', 'IMG'])
    return (
      <Box className="erp-mock-thumbs">
        {items.map((t, i) => (
          <button key={`${t}-${i}`} type="button" onClick={() => setItems(items.filter((_, j) => j !== i))}>
            {t}
          </button>
        ))}
        <button type="button" onClick={() => setItems([...items, 'NEW'])}>
          +
        </button>
      </Box>
    )
  },

  formMultiA: () => {
    const [nome, setNome] = useState('')
    const [step, setStep] = useState(1)
    return (
      <Box>
        <p className="small text-muted">Formulário em ordem. Etapa {step} de 3.</p>
        <div className="erp-mock-step-labels">
          <span className={step === 1 ? 'is-now' : ''}>1 Dados</span>
          <span>2 Contato</span>
          <span>3 Anexos</span>
        </div>
        {step === 1 && (
          <Field label="Nome">
            <DemoInput value={nome} onChange={setNome} />
          </Field>
        )}
        <DemoBtn variant="primary" disabled={!nome.trim() || step > 1} onClick={() => setStep(2)}>
          Próximo
        </DemoBtn>
      </Box>
    )
  },
  formMultiB: () => {
    const [step, setStep] = useState(1)
    const [aviso, setAviso] = useState('')
    const labels = ['Dados', 'Contato', 'Anexos']
    return (
      <Box>
        <p className="small text-muted">A etapa seguinte só abre depois da anterior.</p>
        <div className="erp-mock-steps erp-mock-steps--num erp-demo-steps">
          {labels.map((label, idx) => {
            const n = idx + 1
            return (
              <React.Fragment key={label}>
                <button
                  type="button"
                  className={n < step ? 'is-done' : n === step ? 'is-now' : ''}
                  onClick={() => {
                    if (n > step) setAviso('Siga a ordem: avance com Próximo.')
                    else {
                      setAviso('')
                      setStep(n)
                    }
                  }}
                >
                  {n}
                </button>
                {idx < 2 && <i />}
              </React.Fragment>
            )
          })}
        </div>
        <span className="small text-muted">{labels[step - 1]}</span>
        {aviso && <span className="small text-danger d-block">{aviso}</span>}
        <DemoBtn variant="primary" disabled={step === 3} onClick={() => setStep(step + 1)}>
          Próximo
        </DemoBtn>
      </Box>
    )
  },
  formMultiC: () => {
    const [step, setStep] = useState(1)
    const [email, setEmail] = useState('')
    const labels = ['Dados', 'Contato', 'Anexos']
    return (
      <Box>
        <p className="small text-muted">Wizard: o formulário segue esta ordem.</p>
        <div className="erp-mock-steps erp-mock-steps--num erp-demo-steps">
          {labels.map((label, idx) => {
            const n = idx + 1
            return (
              <React.Fragment key={label}>
                <button
                  type="button"
                  className={n < step ? 'is-done' : n === step ? 'is-now' : ''}
                  onClick={() => {
                    if (n <= step) setStep(n)
                  }}
                >
                  {n}
                </button>
                {idx < 2 && <i />}
              </React.Fragment>
            )
          })}
        </div>
        <div className="erp-mock-step-labels">
          {labels.map((label) => (
            <span key={label}>{label}</span>
          ))}
        </div>
        {step === 2 && (
          <Field label="E-mail">
            <DemoInput value={email} onChange={setEmail} />
          </Field>
        )}
        {step !== 2 && <span className="small text-muted">Etapa {step} — {labels[step - 1]}</span>}
        <div className="erp-mock-row">
          <DemoBtn variant="outline" disabled={step === 1} onClick={() => setStep(step - 1)}>
            Voltar
          </DemoBtn>
          <DemoBtn variant="primary" disabled={step === 3} onClick={() => setStep(step + 1)}>
            Próximo
          </DemoBtn>
        </div>
      </Box>
    )
  },
}

export default function FormMock({ mockId }) {
  const Comp = FORM_MOCKS[mockId]
  if (!Comp) {
    return <div className="erp-mock-box text-muted small">Form mock: {mockId}</div>
  }
  return <Comp />
}
